import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { config } from 'src/app/valueObject/config';
import { AppService } from 'src/app/service/app.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { UserDetailsService } from 'src/app/service/user-details.service';
import { UserDetails } from '../valueObject/userDetails';
import { User } from '../valueObject/user';
import { ToastrService } from 'ngx-toastr';

declare var $: any;

@Component({
    selector: 'app-component',
    templateUrl: './component.component.html',
    styleUrls: ['./component.component.css'],
    standalone: false
})
export class ComponentComponent implements OnInit {

  config: any = config;
  userDetails: UserDetails;
  user: User;
  collateralMenu: any = {};

  constructor(private titleService: Title,
    private appService: AppService,
    private router: Router,
    private userDetailsService: UserDetailsService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
    this.titleService.setTitle("Home");
    this.getUserDetails();
  }

  fullscreen: boolean = true;
  clicktoggle() {
    this.fullscreen = !this.fullscreen;
  }

  hideSidebar() {
    this.fullscreen = true;
  }

  getUserDetails() {
    this.appService.getUserDetails(0).pipe(
      catchError((error: any) => {
        this.userDetails = null;
        this.toastr.clear();
        this.toastr.warning("Session Expired. Please login again.");
        this.logout();
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.userDetailsService.setUserDetails(response.data && response.data[0]);
          this.userDetails = response.data[0];
          let menuList = this.userDetails.menusList;
          this.collateralMenu = menuList.find(data => data.menuCode == 'collateral');
        } else {
          this.userDetails = null;
          this.toastr.clear();
          this.toastr.warning("Session Expired. Please login again.");
         this.logout();
        }
      }
    );
  }

  changePassword() {
    this.router.navigate(['/form/changepassword'], { queryParams: { 'page': 'home', 'username': this.userDetails.loginId } })
  }

  profile() {
    this.router.navigate(['/form/profile']);
  }

  logout() {
    this.appService.logout({}).pipe(
      catchError((error: any) => {
        // localStorage.removeItem('token');
        // localStorage.removeItem('userDetails');
        // localStorage.removeItem('username');
        // localStorage.removeItem('salt');
      //  this.router.navigate(['login/restrictDirectLogout']);
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      //if (response.message == "SUCCESSFULL") {
        // localStorage.removeItem('token');
        // localStorage.removeItem('userDetails');
        // localStorage.removeItem('username');
        // localStorage.removeItem('salt');
        this.router.navigate(['login/restrictDirectLogout']);
      //}
    });
  }
}
